module.exports = __webpack_public_path__ + "static/media/iceberg.5a61a485.jpg";